import logEvent from 'analytics/logEvent';
import cn from 'classnames';
import useTranslationAndTypograph from 'hooks/useTranslationAndTypograph';
import React, { useState } from 'react';

import { getTariff } from 'domains/products/products.utils';

import Button from 'components/basic/Button';

import { useAppDispatch } from 'redux-store';
import type { ProductType } from 'redux-store/slices/products/types';
import chargePurchaseThunk from 'redux-store/thunks/purchases/chargePurchaseThunk';

import { chargeFinish } from '../../../../../redux-store/slices/purchases';

import s from './FreeActivationButton.module.scss';

interface Props {
  selectedPlan: ProductType;
  coupon?: string;
}

export default function FreeActivationButton({
  selectedPlan,
  coupon,
}: Props): JSX.Element {
  const t = useTranslationAndTypograph();
  const [isButtonDisabled, setButtonDisabled] = useState(false);
  const dispatch = useAppDispatch();

  async function processPayment(): Promise<void> {
    setButtonDisabled(true);

    logEvent('Web_Payment_Redeem_Button_Clicked', {
      coupon,
      tariff: getTariff(selectedPlan),
      duration: selectedPlan.prices[0].interval_count,
      plan_id: selectedPlan.id,
    });

    const price_ids = selectedPlan.prices.map(price_id => price_id.stripe_price_id);

    const chargeResult = await dispatch(
      chargePurchaseThunk({
        coupon,
        product_id: selectedPlan.id,
        price_ids: price_ids,
        extra: {
          interval: selectedPlan.prices[0].interval,
          tariff: getTariff(selectedPlan),
          discount: Number(selectedPlan.prices[0].discount),
          price: selectedPlan.prices[0].discount_price ?? selectedPlan.prices[0].price,
        },
      }),
    ).unwrap();

    dispatch(chargeFinish(chargeResult));

    setButtonDisabled(false);
  }

  return (
    <div className={s.wrapper}>
      <Button
        className={cn(s.button, 'cy-redeem-button')}
        size="large"
        isLoading={isButtonDisabled}
        onClick={processPayment}
      >
        {t('redeem')}
      </Button>
    </div>
  );
}
